"use strict";

const { get } = require("jquery");
const config = require('../../../../../config/locales_json/packs/private/admin/universities.json');
const language = $('body').data("language");

// Class definition

var UniversitiesDatatable = function() {
  // Private functions
  var _init = function() {
      var datatable = $('#kt_datatable_universities').KTDatatable({
          // datasource definition
          data: {
            type: 'remote',
            method: 'GET',
            source: {
              read: {
                url: '/admin/universidades/get_universities.json?scope='+$('#kt_datatable_universities').data('scope')+'&status='+$('#kt_datatable_universities').data('status'),
                method: 'GET',
                map: function(data) {
                  //console.log(data)
                  //$("#kt_subheader_total").html(data.length + " Total")

                  setTimeout(() => {
                    $('div#kt_datatable_universities .tp').tooltip('enable');
                  }, 2000);

                  return data.data
                }
              },
            },
            pageSize: 20,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            serverFiltering: true,
            fixedHeader: true
          },

          // layout definition
          layout: {
              scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
              footer: false, // display/hide footer
          },

          // column sorting
          sortable: true,

          pagination: true,

          translate: {
            records: {
              processing: getTranslationValue(config, [language, "UniversitiesDatatable", "translate", "records-processing"], 'Cargando...'),
              noRecords: getTranslationValue(config, [language, "UniversitiesDatatable", "translate", "records-noRecords"], 'No existen universidades en el sistema')
            },
            toolbar: {
              pagination: {
                items: {
                  default: {
                    first: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-first"], 'Primero'),
                    prev: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-prev"], 'Anterior'),
                    next: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-next"], 'Siguiente'),
                    last: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-last"], 'Último'),
                    more: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-more"], 'Más páginas'),
                    input: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-input"], 'Página number'),
                    select: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
                  },
                  info: getTranslationValue(config, [language, "UniversitiesDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} universidades')
                }
              }
            }
          },

          // columns definition
          columns: [{
              field: 'name',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "name", "title"],'Universidad'),
              width: 300,
              template: function(data) {
                var name = data.name;

                var output = '<div class="d-flex align-items-center">\
                    <div class="ml-0">\
                        <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">' + name + '</div>\
                    </div>\
                </div>';

                return output;
              },
          }, {
              field: 'nicename',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "nicename", "title"],'País'),
              width: 120,
              template: function(data) {
                var output = '<div class="font-weight-bolder mb-0">' + data.nicename + '</div>';

                return output;
            },
          }, {
              field: 'Status',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Status", "title"],'Estado'),
              width: 100,
              // callback function support for column rendering
              template: function(row) {
                if(row.is_valid){
                  const validText = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Status", "valid-output"], 'Validada');

                  var output = '<span class="label label-lg font-weight-bold label-inline label-open">'+validText+'</span>';
                } else {
                  const inValidText = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Status", "invalid-output"], 'No Validada');

                  var output = '<span class="label label-lg font-weight-bold label-inline label-closed">'+inValidText+'</span>';
                }

                return output;
              },
          }, {
              field: 'Actions',
              title: getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "title"], 'Acciones'),
              sortable: false,
              width: 130,
              overflow: 'visible',
              autoHide: false,
              template: function(row) {
                if(row.is_deletable){
                  const editTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable", "output_a_1"], 'Editar');
                  const deleteTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable", "output_a_2"], 'Eliminar');

                  var output = '<div class="d-flex align-items-center container-actions-table">\
                                  <a href="/admin/universidades/'+ row.id +'/edit" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="'+editTitle+'"><i class="far fa-edit"></i></a>\
                                  <button type="button" class="icon delete-button tp" data-toggle="tooltip" data-theme="dark" title="'+deleteTitle+'" data-id="'+ row.id +'" data-toggle="modal" data-target="#delete_university_modal">\
                                    <i class="fas fa-trash-alt"></i>\
                                  </button>\
                                </div>';
                } else {
                  const editTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable_else", "output_a_1"], 'Editar');
                  const deleteTitle = getTranslationValue(config, [language, "UniversitiesDatatable", "columns", "Actions", "is_deletable_else", "output_a_2"], 'Eliminar');

                  var output = '<div class="d-flex align-items-center container-actions-table">\
                                  <a href="/admin/universidades/'+ row.id +'/edit" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="'+editTitle+'"><i class="far fa-edit"></i></a>\
                                  <button type="button" class="icon delete-button not-delete tp" data-toggle="tooltip" data-theme="dark" title="'+deleteTitle+'" data-id="'+ row.id +'" data-toggle="modal" data-target="#delete_university_modal">\
                                    <i class="fas fa-trash-alt"></i>\
                                  </button>\
                                </div>';
                }

                return output;
              }
          }],
          search: {
            input: $('#kt_subheader_universities_search_form'),
          }
      });
  };

  return {
    // public functions
    init: function() {
        _init();
    },
  };
}();

jQuery(document).ready(function() {
    if($("#kt_datatable_universities").length > 0){
      UniversitiesDatatable.init();
    }

    /*************
     * ELIMINAR UNIVERSIDADES
     *
     * - Logica de activacion de modal,
     * - Asignacion de informacion a hidden field del modal
     * - Validacion y ejecución del formulario
     */
    // Al hacer click en eliminar una universidad
    $("#kt_datatable_universities").on("click", ".delete-button", function(e){
        $('#delete_university_modal').modal('toggle')
        // Obtiene el id de la universidad
        var universityID = $(this).attr("data-id")
        // Asigna el id de la universidad en el campo hidden del modal
        $("#delete_university_modal #hidden_modal_id").val(universityID)
        // Se asigna la url correspondiente
        var url = '/admin/universidades/'+ universityID;
        $("#form_modal_delete_university").attr("action", url)
        // Si la universidad se debe archivar porque tiene usuarios con la universidad asignada
        if($(this).hasClass("not-delete")){
            const descriptionText = getTranslationValue(config, [language, "click-delete-button", "description_text"], 'Esta universidad ya está asociada a un postulante, no se puede eliminar pero si quedará archivado. Esta acción no se puede revertir.');
            const btnText = getTranslationValue(config, [language, "click-delete-button", "btn_text"], 'Archivar');

            // Modifica la descripcion del modal
            $("#delete_university_modal .modal-body .description").text(descriptionText)
            // Modifica el texto del boton
            $("#delete_university_modal .modal-footer #send_modal_delete_university_form").text(btnText)
            // Agrega la clase not-delete para que al enviar el formulario muestre el texto de "Archivando..."
            $("#delete_university_modal .modal-footer #send_modal_delete_university_form").addClass("not-delete")
        // Si la universidad debe eliminarse modifica la info del modal por si anteriormente el modal fue abierto
        // por alguna universidad que se debio archivar
        } else {
            const descriptionText = getTranslationValue(config, [language, "click-delete-button", "else_description_text"], 'Esta acción no se puede revertir.');
            const btnText = getTranslationValue(config, [language, "click-delete-button", "else_btn_text"], 'Eliminar');

            // Modifica la descripcion del modal
            $("#delete_university_modal .modal-body .description").text(descriptionText)
            // Modifica el texto del boton
            $("#delete_university_modal .modal-footer #send_modal_delete_university_form").text(btnText)
            // Quita la clase not-delete para que al enviar el formulario muestre el texto de "Eliminando..."
            $("#delete_university_modal .modal-footer #send_modal_delete_university_form").removeClass("not-delete")
        }

    })

    // Al cerrar el modal limpia la url y el hidden
    $("#delete_university_modal .close").on("click", function(e){
        cleanUniversityModalFields()
    })

    // Al hacer click en confirmar eliminacion de universidad
    $("#delete_university_modal #cancel_modal_delete_university_form").on("click", function(e){
        cleanUniversityModalFields()
    })

    // Al hacer click en enviar universidad
    $("#delete_university_modal #send_modal_delete_university_form").on("click", function(e){
        // Valida que el campo hidden tenga información
        var universityID = $("#delete_university_modal #hidden_modal_id").val()
        // Si tiene informacion ejecuta el formulario
        if(universityID.length > 0) {
            // Se desabilitan las acciones
            // Si se esta archivando una universidad
            if($(this).hasClass("not-delete")){
                const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-university-form", "universityId-length-not-delete"], 'Archivando...');

                // Cambia el texto del boton a Archivando
                $(this).addClass("disabled").text(disabledText)
            // De lo contrario esta eliminando una universidad
            } else {
                const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-university-form", "universityId-length-not-delete-else"], 'Eliminando...');

                // Cambia el texto del boton a Eliminando
                $(this).addClass("disabled").text(disabledText)
            }

            $("#delete_university_modal #cancel_modal_delete_university_form").addClass("disabled")
            $("#delete_university_modal #close_delete_university_modal").addClass("disabled")
            $("#form_modal_delete_university").submit()
        } else {
            const disabledText = getTranslationValue(config, [language, "click-modal-delete-local-university-form", "else-universityId-length"], 'Hubo un problema y no se pudo eliminar la universidad. Por favor intente más tarde.');

            // Si no se puede eliminar
            $(".modal-body").find(".error-modal").remove()
            $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+disabledText+'</p></div>')
        }
    })

    // Limpia el campo hidden y la url del form
    function cleanUniversityModalFields(){
        // Limpia si hay errores
        $(".modal-body").find(".error-modal").remove()
        // Limpia el campo hidden
        $("#delete_university_modal #hidden_modal_id").val(null)
        // Se limpia la url correspondiente
        var url = '';
        $("#form_modal_delete_university").attr("action", url)
    }
    /*************
     * FIN ELIMINAR UNIVERSIDAD
     */
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
